// Menu.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Menu as HeadlessMenu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { toast } from "react-toastify";
import StudentAvatar from "../StudentAvatar";
import {
  User,
  FileText,
  Lock,
  LogOut,
  ChevronDown,
  Settings,
  HelpCircle,
} from "lucide-react";

const Menu = ({ isOpen, props, handleClick }) => {
  const studentName = localStorage.getItem("studentName");
  const studentEmail = localStorage.getItem("studentEmail") || "";
  const navigate = useNavigate();

  const menuItems = [
    {
      label: "My Profile",
      icon: User,
      onClick: () => navigate("/dashboard/profile"),
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      label: "Make a Request",
      icon: FileText,
      onClick: () => navigate("/dashboard/makeARequest"),
      color: "text-purple-600",
      bgColor: "bg-purple-50",
    },
    {
      label: "Change Password",
      icon: Lock,
      onClick: () => navigate("/dashboard/changepassword"),
      color: "text-amber-600",
      bgColor: "bg-amber-50",
    },
  ];

  const handleSignOut = () => {
    localStorage.clear();
    navigate("/");
    toast.success("Logged Out Successfully");
  };

  return (
    <HeadlessMenu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          {/* Menu Button */}
          <HeadlessMenu.Button className="flex items-center gap-2 p-1 rounded-full transition-colors ">
            <StudentAvatar />
          </HeadlessMenu.Button>

          {/* Dropdown Menu */}
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-150"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <HeadlessMenu.Items className="absolute right-0 mt-2 w-64 origin-top-right rounded-xl bg-white shadow-lg z-50 overflow-hidden">
              {/* User Info Header */}
              {/* <div className="px-4 py-2 bg-gray-50 border-b border-gray-100">
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0">
                    <StudentAvatar />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                      {studentName || "Student"}
                    </p>
                    {studentEmail && (
                      <p className="text-xs text-gray-500 truncate">
                        {studentEmail}
                      </p>
                    )}
                  </div>
                </div>
              </div> */}

              {/* Menu Items */}
              <div className="p-2">
                {menuItems.map((item, index) => (
                  <HeadlessMenu.Item key={index}>
                    {({ active }) => (
                      <button
                        onClick={item.onClick}
                        className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                          active ? "bg-gray-100" : ""
                        }`}
                      >
                        <div
                          className={`w-8 h-8 ${item.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}
                        >
                          <item.icon className={`w-4 h-4 ${item.color}`} />
                        </div>
                        <span className="font-medium text-gray-700">
                          {item.label}
                        </span>
                      </button>
                    )}
                  </HeadlessMenu.Item>
                ))}
              </div>

              {/* Divider */}
              <div className="border-t border-gray-100"></div>

              {/* Sign Out */}
              <div className="p-2">
                <HeadlessMenu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleSignOut}
                      className={`w-full flex items-center gap-3 px-3 py-1 rounded-lg text-sm transition-colors ${
                        active ? "bg-red-50" : ""
                      }`}
                    >
                      <div className="w-8 h-8 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
                        <LogOut className="w-4 h-4 text-red-600" />
                      </div>
                      <span className="font-medium text-red-600">Sign Out</span>
                    </button>
                  )}
                </HeadlessMenu.Item>
              </div>
            </HeadlessMenu.Items>
          </Transition>
        </>
      )}
    </HeadlessMenu>
  );
};

export default Menu;